import React, { useRef } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import { ASSETS } from '../../data/site';
import { Reveal } from '../Reveal';

// MOBILE: the whole section fits ONE page — heading collapses to a single line
// (words are spans: inline on mobile, stacked from sm: up), timeline tightened,
// and the astronaut image renders as a capped-height wide banner. Desktop unchanged.

const TIMELINE = [{
  year: '2015',
  text: 'Started throwing shows along the Gulf Coast — Pensacola, Mobile and Gulf Shores.'
}, {
  year: '2019',
  text: 'Added Future Astronaut Records — the label branch of Future Astronaut Co. — to release and grow our artists.'
}, {
  year: 'TODAY',
  text: 'Events, a record label and full-scale stage production under one roof.'
}];
export function About() {
  const ref = useRef<HTMLDivElement | null>(null);
  const {
    scrollYProgress
  } = useScroll({
    target: ref,
    offset: ['start end', 'end start']
  });
  const imageY = useTransform(scrollYProgress, [0, 1], [40, -40]);
  return <section id="about" className="relative w-full overflow-hidden py-20 sm:py-28" aria-labelledby="about-heading" data-id="element-52" data-mp="338ypgiuobpw8">
      <div aria-hidden="true" className="pointer-events-none absolute inset-0 -z-10" style={{
      background: 'radial-gradient(45% 55% at 25% 50%, rgba(139,92,255,0.14) 0%, rgba(4,3,12,0) 100%)'
    }} data-id="element-53" data-mp="3cyi6diytt9og" />
      <div ref={ref} className="mx-auto grid w-full max-w-7xl items-center gap-4 px-5 sm:gap-12 sm:px-8 lg:grid-cols-[minmax(0,1.05fr)_minmax(0,1fr)] lg:gap-16" data-id="element-54" data-mp="2kc7aglm5zwxz">
        <div data-id="element-55" data-mp="2u6z6hl03mbqn">
          <Reveal data-id="element-56" data-mp="2uan00k5jmy5d">
            <p className="font-tech text-xs font-semibold tracking-[0.32em] text-cyan/80" data-id="element-57" data-mp="2z7n5asukjwvf">
              SINCE 2015
            </p>
            <h2 id="about-heading" className="text-gradient mt-3 font-display text-2xl leading-[1.15] sm:mt-5 sm:text-4xl sm:leading-[1.1] lg:text-5xl" data-id="element-58" data-mp="9j4beiyxkc0g">
              <span className="inline sm:block" data-id="element-59" data-mp="2ajrfo036hrnr">Dream.</span>{' '}
              <span className="inline sm:block" data-id="element-60" data-mp="2amdixnj1dl06">Love.</span>{' '}
              <span className="inline sm:block" data-id="element-61" data-mp="25kxynxooniiu">Impact.</span>
            </h2>
          </Reveal>
          <Reveal delay={0.1} data-id="element-62" data-mp="2jkp8rnc2werk">
            <p className="mt-3 max-w-xl text-[0.8rem] leading-relaxed text-white/60 sm:mt-7 sm:text-lg" data-id="element-63" data-mp="2jiwbgyncv6w8">
              Future Astronaut started in 2015 as a group of friends booking rooms along the Gulf
              Coast. Ten years later the mission hasn't changed — put the artists we believe in in
              front of the people who need to hear them.
            </p>
          </Reveal>
          <ol className="mt-3 space-y-0 sm:mt-10" data-id="element-64" data-mp="20oh9r19nt04p">
            {TIMELINE.map((item, i) => <Reveal key={item.year} delay={0.14 + i * 0.08} data-id="element-65" data-mp="1vtjvnfxiw0ky" data-mpi={i}>
                <li className="flex gap-3 border-t border-white/10 py-2 sm:gap-5 sm:py-5" data-id="element-66" data-mp="1850oj3q7ltug">
                  <span className="w-12 shrink-0 font-display text-[0.56rem] tracking-[0.12em] text-magenta sm:w-16 sm:text-[0.7rem]" data-id="element-67" data-mp="143fedq527tny">
                    {item.year}
                  </span>
                  <span className="text-[0.7rem] leading-relaxed text-white/60 sm:text-sm" data-id="element-68" data-mp="yriaxqej71nd">{item.text}</span>
                </li>
              </Reveal>)}
          </ol>
        </div>

        <Reveal delay={0.1} data-id="element-69" data-mp="p0xd456om15i">
          <motion.div style={{
          y: imageY
        }} className="relative" data-id="element-70" data-mp="p1ysgluqd9t1">
            <div aria-hidden="true" className="absolute inset-6 -z-10 rounded-full blur-3xl" style={{
            background: 'radial-gradient(circle, rgba(139,92,255,0.35) 0%, rgba(4,3,12,0) 70%)'
          }} data-id="element-71" data-mp="1cqhxmsihh6gw" />
            <img src={ASSETS.astronaut} alt="Astronaut floating in space, the Future Astronaut emblem" loading="lazy" className="h-[190px] w-full rounded-2xl border border-white/10 object-cover object-[center_30%] sm:h-auto sm:rounded-3xl sm:object-center" data-id="element-72" data-mp="17rf5g8nlquqc" />
          </motion.div>
        </Reveal>
      </div>
    </section>;
}